import { z } from 'zod'
import { managerBenefitCommonSchema } from '~library/models'

export const manageBenefitRedeemShoppingCartSchema = z
  .object({
    /** 禮遇商品Id */
    id: z.string(),
    /** 數量 */
    quantity: z.number(),
    /** 券號 */
    couponNo: z.array(z.string())
  })
  .merge(managerBenefitCommonSchema)

export interface ManageBenefitRedeemShoppingCart
  extends z.infer<typeof manageBenefitRedeemShoppingCartSchema> {}
